import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SelectOption } from 'src/app/shared/components/atoms/model/option.interface';
import { TaxValidationService } from './service/tax-validation.service';
import { Constants, IIBBDocumentCategory, InfoAfip, InfoCuil, StateName, TaxValidation, TypePerson } from './model/tax-validation';
import { SesionService } from 'src/app/core/service/sesion.service';
import { Atribute, PotentialCustomer } from '../potential-customer/model/potential-customer';
import { ProvinceIibbCategory } from './model/province-iibb-category.interface';
import { Subscription } from 'rxjs';
import { MapService } from 'src/app/shared/components/molecules/map/service/map.service';
import { ToastrService } from 'ngx-toastr';
import { IibbCategory } from 'src/app/core/model/constans';

@Component({
  selector: 'app-tax-validation',
  templateUrl: './tax-validation.component.html',
  styleUrls: ['./tax-validation.component.scss'],
})
export class TaxValidationComponent implements OnInit {
  taxForm: FormGroup;
  submitted: boolean;
  categorizedAfip: boolean = false;
  arbaPadron: boolean = false;
  cbaPadron: boolean = false;
  erPadron: boolean = false;
  sfPadron: boolean = false;
  isBsas: boolean = false;
  isCba: boolean = false;
  isEr: boolean = false;
  isSf: boolean = false;
  alicuota: number[] = [0];
  alicuotaNotPadron: number = 0;
  alicuotaNotPadronNotRegistered: number = 0;
  loading: boolean;
  cuitNotEnrolled: boolean;
  cuitNotRegistered: boolean;
  IIBBCondition: number;
  warningCuit: boolean = false;
  warningCuitText = '';
  potentialCustomer: PotentialCustomer | null;
  sessionData: TaxValidation | null;
  atributes: Atribute[] | null;
  IIBBOptions: SelectOption[];
  docTypesOptions: SelectOption[];
  genderOptions: SelectOption[];
  REBA: boolean = false;
  isDuplicated: boolean = false;
  state: string = '';
  numberIIBBRequired = false;
  infoAfip: InfoAfip | undefined;
  infoCuil: InfoCuil | undefined;
  name: string = '';
  lastName: string = '';
  attachIIBBDocument: IIBBDocumentCategory | undefined;
  municipalContribution: boolean = false;
  convenioMultilateral: boolean = false;
  simplifiedMonotributo: boolean = false;
  jurisdictions: SelectOption[] = [];
  showJurisdiction: boolean = false;
  @Output()
  onComplete = new EventEmitter<number>();
  cuitSubscription: Subscription = new Subscription();
  @Output()
  onBack = new EventEmitter();

  constructor(
    private readonly fb: FormBuilder,
    private readonly services: TaxValidationService,
    private readonly sesion: SesionService,
    private readonly serviceMap: MapService,
    private readonly cd: ChangeDetectorRef,
    private readonly toastr: ToastrService,
  ) {
    this.submitted = false;
    this.loading = false;
    this.cuitNotEnrolled = false;
    this.cuitNotRegistered = false;
    this.potentialCustomer = this.sesion.getItem('potential_customer');
    this.atributes = this.sesion.getItem('atribute');
    this.setAtributes(this.atributes);
    this.sessionData = this.sesion.getItem('tax_validation');
    this.taxForm = this.fb.group({
      cuit: [
        this.sessionData ? this.sessionData.numIdentification : '',
        [Validators.required, Validators.minLength(11), Validators.maxLength(11)],
      ],
      noCuit: [this.sessionData ? this.sessionData.noCuit : false],
      IIBBCondition: [this.sessionData ? this.sessionData.IIBBCondition : '', Validators.required],
      IIBBNumber: [
        this.sessionData ? this.sessionData.IIBBNumber : '',
        [Validators.required, Validators.maxLength(11)],
      ],
      REBA: [this.sessionData ? this.sessionData.REBA : false],
      codeREBA: [this.sessionData ? this.sessionData.infoREBA?.code : null],
      expiredREBA: [this.sessionData ? this.sessionData.infoREBA?.expiredDate : null],
      municipalContribution: [this.sessionData?.municipalContribution ? this.sessionData.municipalContribution : false],
      numMunicipalContribution: [
        this.sessionData?.numMunicipalContribution ? this.sessionData.numMunicipalContribution : '',
      ],
      iibbJurisdiction: [null],
    });

    this._resetAfipFromSession();
    this.changeCuitOrCuil();

    if (this.sessionData?.IIBBCondition == '4') {
      this._setFormJurisdiction();
    }

    // Set de los valores de jurisdiccion para convenio multilateral
    this.services.getIIBBJurisdiction().subscribe((data) => {
      this.jurisdictions = data;
    });

    this.taxForm.controls['cuit'].valueChanges.subscribe((value) => {
      this.changeCuitOrCuil();
    });
    this.taxForm.controls['municipalContribution'].valueChanges.subscribe((value) => {
      if (this.state == 'Chubut') {
        this.numMunicipalContributionIsRequired(value);
      }
    });

    console.log('antes de potentialCustomer')
    if (this.potentialCustomer) {
      console.log('desp');
      this.state = this.potentialCustomer?.location.state.toLowerCase();
      console.log('statel',this.state)
    }

    this.taxForm.controls['IIBBCondition'].valueChanges.subscribe((value) => {
      this.showJurisdiction = false;
      this.taxForm.controls['iibbJurisdiction'].clearValidators();
      this.taxForm.controls['iibbJurisdiction'].updateValueAndValidity();
      if (value != '') {
        value == 1 ? this.changeIIBBNumberValidations(false) : this.changeIIBBNumberValidations(true);
        if ((value != 1 && this.state == StateName.BuenosAires) || value == 4) {
          this.SetCuitInIIBBNumber();
        }
        if (value == IibbCategory.ConvenioMultilateral) {
          this._setFormJurisdiction();
          let cuit = this.taxForm.controls['cuit'].value;
          this.services.getIIBBRate(cuit, this.state, true).subscribe((data) => {
            if (this.infoAfip) this.infoAfip.convenioMultilateral = true;
            let alicuotaBsAs = data.alicuotaBsAs;
            let alicuotaCba = data.alicuotaCba;
            let alicuotaEr = data.alicuotaEr;
            let alicuotaSf = data.alicuotaSf;
            this.arbaPadron =
              data.alicuotaBsAs && data.alicuotaBsAs != 'no se encontro registro en el padron, para Cuit: ' + cuit;
            this.cbaPadron =
              data.alicuotaCba && data.alicuotaCba != 'no se encontro registro en el padron, para Cuit: ' + cuit;
            this.erPadron =
              data.alicuotaEr && data.alicuotaEr != 'no se encontro registro en el padron, para Cuit: ' + cuit;
            this.sfPadron =
              data.alicuotaSf && data.alicuotaSf != 'no se encontro registro en el padron, para Cuit: ' + cuit;
              
            if (!this.arbaPadron) {
              alicuotaBsAs = this.state == StateName.BuenosAires ? 8 : null;
            } else {
              alicuotaBsAs = Number(alicuotaBsAs.replace(',', '.'));
            }
            if (!this.cbaPadron) {
              alicuotaCba = this.state == StateName.Cordoba ? 6 : null;
            } else {
              alicuotaCba = Number(alicuotaCba.replace(',', '.'));
            }
            if (!this.erPadron) {
              alicuotaEr = this.state == StateName.EntreRios ? 6 : null;
            } else if (alicuotaEr) {
              alicuotaEr = Number(alicuotaEr.replace(',', '.'));
            }
            if (!this.sfPadron) {
              alicuotaSf = this.state == StateName.SantaFe ? 6 : null;
            } else {
              alicuotaSf = Number(alicuotaSf.replace(',', '.'));
            }
            
            if (!alicuotaEr && alicuotaEr != 0) {
              this.alicuota = [alicuotaBsAs, alicuotaCba, alicuotaSf];
            } else {
              this.alicuota = [alicuotaBsAs, alicuotaCba, alicuotaEr, alicuotaSf];
            }

            if (this.categorizedAfip) this.deleteOptionIIBB('NO INSCRIPTO');
          });
        }
      }
    });
    this.IIBBOptions = [];
    this.IIBBCondition = this.sessionData?.IIBBCondition ? Number(this.sessionData.IIBBCondition) : 0;
    this.docTypesOptions = [];
    this.genderOptions = [];
  }

  ngOnInit(): void {
    this.setInfo();
    this.getIIBBOptions();
    this.docTypesOptions = this.services.getDocTypes();
    this.genderOptions = this.services.getGenders();
  }

  back() {
    this.onBack.emit();
  }

  numMunicipalContributionIsRequired(required: boolean) {
    if (required) {
      this.taxForm.controls['numMunicipalContribution'].addValidators(Validators.required);
    } else {
      this.taxForm.controls['numMunicipalContribution'].setValue('');
      this.taxForm.controls['numMunicipalContribution'].clearValidators();
      this.taxForm.controls['numMunicipalContribution'].setValidators(null);
      this.taxForm.controls['numMunicipalContribution'].setErrors(null);
    }
  }

  setState() {
    if (this.state == StateName.BuenosAires) {
      this.isBsas = true;
    } else if (this.state ==  StateName.Cordoba) {
      this.isCba = true;
    } else if (this.state == StateName.EntreRios) {
      this.isEr = true;
    } else if (this.state == StateName.SantaFe) {
      this.isSf = true;
    }
  }

  setInfo() {
    this.setState();
    this.loading = false;
    let municipalContribution;
    if (this.infoAfip?.municipalContribution) {
      municipalContribution = this.infoAfip?.municipalContribution != 'N';
    } else {
      municipalContribution = false;
    }
    if (!municipalContribution) {
      municipalContribution = this.taxForm.controls['municipalContribution'].value;
    }
    this.conditionMunicipalAfipResp(municipalContribution);
  }

  setAtributes(data: Atribute[] | null) {
    if (data != null) {
      data.forEach((data) => {
        if (data.attributeName == Constants.REBA) {
          this.REBA = data.value != 0;
        }
        if (data.attributeName == Constants.CONTRIBUTION_MUNICIPAL) {
          this.municipalContribution = data.value != 0;
        }
        if (data.attributeName == Constants.CONDICION_IIBB) {
          this.attachIIBBDocument = {
            required: data.value != 0,
            upload: true,
          };
        }
      });
    }
  }

  setFlagsAfip() {
    this.conditionMunicipalAfipResp(false);
    this.loading = false;
    this.convenioMultilateral = false;
    this.simplifiedMonotributo = false;
  }

  changeCuitOrCuil() {
    this.setFlagsAfip();
    let cuit = this.taxForm.controls['cuit'].value;
    if (cuit.length == 11) {
      this.warningCuit = false;
      this.services.getDataAfip(cuit).subscribe(
        (value) => {
          this.services
            .getDuplicated(cuit, this.potentialCustomer?.location.street, this.potentialCustomer?.location.streetNumber)
            .subscribe((data) => {
              this.isDuplicated = data;
              if (this.isDuplicated) {
                this.warningCuitText =
                  'Registramos una solicitud abierta para este Nro de Cuit. Por favor esperar al tratamiento de la misma. Cualquier duda contactar al centro de servicios al cliente. Gracias!';
              } else {
                this.warningCuitText = 'Cuit Invalido.';
              }
              this.cd.detectChanges();
              console.log('el cuit: ', cuit);
              console.log('esta duplicado:  ', data);
            });
          if (value.datosGenerales.tipoClave == 'CUIL') {
            this.setCuitOrCuil(true);
            this.lastName = value.datosGenerales.apellido;
            this.name = value.datosGenerales.nombre;
            if (!this.name || this.name == 'undefined' || this.name == undefined) {
              this.name = '';
            }
            if (!this.lastName || this.lastName == 'undefined' || this.lastName == undefined) {
              this.lastName = '';
            }

            this.infoCuil = {
              name: this.name,
              lastName: this.lastName,
              typePerson: 'F',
              bussinesName: this.lastName + ' ' + this.name,
            };
            this.getAlicuota();
            this.cd.detectChanges();
          } else {
            this.setCuitOrCuil(false);
            this.taxForm.controls['IIBBCondition'].setValue('');
            let localidad = value.datosGenerales.domicilioFiscal.localidad
              ? value.datosGenerales.domicilioFiscal.localidad
              : '';
            let provincia = value.datosGenerales.domicilioFiscal.descripcionProvincia
              ? value.datosGenerales.domicilioFiscal.descripcionProvincia
              : '';
            let direction =
              value.datosGenerales.domicilioFiscal.direccion +
              ' ' +
              value.datosGenerales.domicilioFiscal.codPostal +
              ' ' +
              localidad +
              ' ' +
              provincia;
            if (value.datosGenerales) {
              this.name = value.datosGenerales?.nombre?.substring(0, 40)?? '';
              this.lastName = value.datosGenerales?.apellido?.substring(0, 40)?? '';
              let info: InfoAfip = {
                bussinesName: value.datosGenerales?.razonSocial?.substring(0, 40),
                taxResidence: direction,
                typePerson: value.datosGenerales.tipoPersona.charAt(0),
                ivaCondition: value.condicionIVA ? value.condicionIVA : '',
                SH: false,
                convenioMultilateral: false,
                simplifiedMonotributo: false,
                municipalContribution: 'N',
              };
              if (value.condicionIIBB == IibbCategory.ConvenioMultilateral) {
                info.convenioMultilateral = true;
                this.convenioMultilateral = true;
                this.taxForm.controls['IIBBCondition'].setValue(IibbCategory.ConvenioMultilateral);
                this._setFormJurisdiction();
              } else if (value.condicionIIBB == IibbCategory.RegimenSimplificado) {
                this.simplifiedMonotributo = true;
                info.simplifiedMonotributo = true;
                this.taxForm.controls['IIBBNumber'].setValue(cuit);
                this.taxForm.controls['IIBBCondition'].setValue(IibbCategory.RegimenSimplificado);
              } else {
                this.IIBBOptions = [];
                this.getIIBBOptions();
              }
              if (value.RSCiudadCoroba && this.municipalContribution) {
                this.conditionMunicipalAfipResp(true);
                info.municipalContribution = 'E';
              }
              if (info.typePerson == TypePerson.FISICA) {
                let lastName = value.datosGenerales.apellido != 'undefined' ? value.datosGenerales.apellido : '';
                let name = value.datosGenerales.nombre != 'undefined' ? value.datosGenerales.nombre : '';
                let bussinesName = lastName + ' ' + name;
                info.bussinesName = bussinesName.substring(0, 40);
              }
              if (info.typePerson == TypePerson.JURIDICA && info.bussinesName) {
                info.SH = this.isSH(info.bussinesName);
              }
              this.infoAfip = info;
            } else {
              this.infoAfip = undefined;
            }

            if (value.condicionIVA != 'NO CATEGORIZADO') {
              console.log('afip categorizado')
              if (this.infoAfip) {
                this.infoAfip.categorizedAfip = true;
              }
              this.afipCategorized(cuit);
            } else {
              console.log('afip no categorizado')

              this.afipNotCategorized(cuit);
            }
            this.cd.detectChanges();
          }
        },
        (error) => {
          this.setError(error.message);
        },
      );
    }
  }

  setError(message: string) {
    this.IIBBOptions = [];
    this.getIIBBOptions();
    this.infoAfip = undefined;
    this.toastr.error(message);
    this.warningCuit = true;
    if (message?.includes('La CUIT del contribuyente fue limitada')) {
      this.warningCuitText = 'Cuit Bloqueado por Afip';
    } else {
      this.warningCuitText = 'Cuit Invalido.';
    }
    this.cd.detectChanges();
  }

  deleteOption(array: any[], name: string): any[] {
    const index = array.findIndex((item) => item.text === name);
    if (index !== -1) {
      array.splice(index, 1);
    }
    return array;
  }

  isSH(data: string) {
    const dataToCompare = data.toUpperCase();
    if (
      dataToCompare.includes('S.H.') ||
      dataToCompare.includes('SH') ||
      dataToCompare.includes('S H') ||
      dataToCompare.includes('SOCIEDAD DE HECHO') ||
      dataToCompare.includes('S.H') ||
      dataToCompare.includes('S H.') ||
      dataToCompare.includes('SH,') ||
      dataToCompare.includes('S H,')
    ) {
      return true;
    } else {
      return false;
    }
  }

  changeIIBBNumberValidations(required: boolean) {
    if (required) {
      this.taxForm.controls['IIBBNumber'].addValidators(Validators.required);
      this.taxForm.controls['IIBBNumber'].addValidators(Validators.maxLength(11));
      this.numberIIBBRequired = true;
    } else {
      this.numberIIBBRequired = false;
      this.taxForm.controls['IIBBNumber'].setValue('');
      this.taxForm.controls['IIBBNumber'].clearValidators();
      this.taxForm.controls['IIBBNumber'].setValidators(null);
      this.taxForm.controls['IIBBNumber'].setErrors(null);
      this.taxForm.controls['IIBBNumber'].updateValueAndValidity();
    }
  }
  afipCategorized(cuit: string) {
    this.categorizedAfip = true;
    console.log('isCba', this.isCba)
    console.log('isBsas', this.isBsas)
    console.log('isSf', this.isSf)
    if (this.isBsas || this.isCba || this.isEr || this.isSf) {
      this.getAlicuota();
      if (this.taxForm.controls['IIBBCondition'].value != IibbCategory.ConvenioMultilateral) {
        this.services.getIIBBRate(cuit, this.state, false).subscribe((data) => {
          if (data.alicuota == 'no se encontro registro en el padron, para Cuit: ' + cuit) {
            this.setNotPadronConfiguration(this.state);
          } else {
            this.deleteOptionIIBB('NO INSCRIPTO');
            this.setPadronConfiguration(this.state, data.alicuota);
          }
        });
      }
    }
  }

  conditionMunicipalAfipResp(data: boolean) {
    this.taxForm.controls['municipalContribution'].setValue(data);
  }

  getAlicuota() {
    const attribute: any = this.sesion.getItem('atribute');
    const notPadron = attribute.find((atr: { attributeName: string }) => atr.attributeName == 'NO_PADRON');
    const notPadronNotRegistered = attribute.find(
      (atr: { attributeName: string }) => atr.attributeName == 'NO_INSCRIPTO_NO_PADRON',
    );
    if (notPadron) {
      this.alicuotaNotPadron = notPadron.value;
    }
    if (notPadronNotRegistered) {
      this.alicuotaNotPadronNotRegistered = notPadronNotRegistered.value;
    }
  }

  afipNotCategorized(cuit: string) {
    console.log('isCba', this.isCba)
    console.log('isBsas', this.isBsas)
    console.log('isSf', this.isSf)
    if (this.isBsas || this.isCba || this.isEr || this.isSf) {
      this.getAlicuota();
      if (this.taxForm.controls['IIBBCondition'].value != IibbCategory.ConvenioMultilateral) {
        this.services.getIIBBRate(cuit, this.state, false).subscribe((data) => {
          if (data.alicuota == 'no se encontro registro en el padron, para Cuit: ' + cuit) {
            this.setNotPadronConfiguration(this.state);
          } else {
            this.setPadronConfiguration(this.state, data.alicuota);
          }
        });
      }
    } else {
      this.taxForm.controls['IIBBCondition'].setValue(1);
    }
  }

  async onSubmit() {
    if (!this.loading) {
      this.submitted = true;
      this.taxForm.controls['IIBBCondition'].value != '1'
        ? this.changeIIBBNumberValidations(true)
        : this.changeIIBBNumberValidations(false);
      if (this.taxForm.valid && !this.warningCuit) {
        this.loading = true;
        let data: TaxValidation = await this.createTaxDto();
        this.sesion.setItem('tax_validation', data);
        this.formComplete();
      }
    }
  }

  async createTaxDto(): Promise<TaxValidation> {
    this.convenioMultilateral = this.convenioMultilateral ?? this.infoAfip?.convenioMultilateral;
    this.simplifiedMonotributo = this.simplifiedMonotributo ?? this.infoAfip?.simplifiedMonotributo;
    let data: TaxValidation = {
      numIdentification: this.taxForm.controls['cuit'].value,
      noCuit: this.taxForm.controls['noCuit'].value,
      IIBBCondition: this.taxForm.controls['IIBBCondition'].value ?? this.IIBBCondition,
      IIBBNumber: this.taxForm.controls['IIBBNumber'].value,
      IIBBJurisdiction: this.taxForm.controls['iibbJurisdiction'].value,
      REBA: this.taxForm.controls['REBA'].value,
      infoREBA: {
        code: this.taxForm.controls['codeREBA'].value,
        expiredDate: this.taxForm.controls['expiredREBA'].value,
      },
      infoCuil: this.infoCuil,
      municipalContribution: this.taxForm.controls['municipalContribution'].value,
      name: this.name,
      lastName: this.lastName,
      nameComplete: this.infoCuil?.bussinesName ?? '',
      aliCuota: [0],
      numMunicipalContribution: this.taxForm.controls['numMunicipalContribution'].value,
      arbaPadron: this.arbaPadron,
      cbaPadron: this.cbaPadron,
      erPadron: this.erPadron,
      sfPadron: this.sfPadron,
      categorizedAfip: this.categorizedAfip,
    };
    if (!data.noCuit) {
      data.infoAfip = this.infoAfip;
      data.directionSame = await this.validateDirec(this.infoAfip);
    } else {
      data.directionSame = true;
    }
    if (this.attachIIBBDocument?.upload) {
      data.attachIIBBDocument = this.attachIIBBDocument;
    }
    if (data.municipalContribution && data.infoAfip?.municipalContribution == 'N') {
      data.infoAfip.municipalContribution = 'S';
    } else if (!this.municipalContribution && !data.municipalContribution) {
      data.municipalContribution = null;
    }
    this._setAlicuota(data);
    return data;
  }

  private _setAlicuota(data: TaxValidation) {
    this.getAlicuota();
    let iibb = this.taxForm.controls['IIBBCondition'].value;
    if (iibb == IibbCategory.ConvenioMultilateral) {
      data.aliCuota = this.alicuota;
    }
    if (!this.isBsas && !this.isCba && !this.isEr && !this.isSf) return;
    if (this.arbaPadron || this.erPadron || this.sfPadron || (this.cbaPadron && this.categorizedAfip)) {
      data.aliCuota = this.alicuota;
      if (iibb == IibbCategory.Exento) {
        data.aliCuota = [0];
      }
    } else if ((iibb != IibbCategory.NoInscripto && this.isCba) || this.isBsas || this.isEr || this.isSf) {
      data.aliCuota = [this.alicuotaNotPadron];
    } else if (iibb == IibbCategory.NoInscripto && this.isCba) {
      data.aliCuota = [this.alicuotaNotPadronNotRegistered];
    } else {
      data.aliCuota = this.alicuota;
    }
  }

  formComplete() {
    this.onComplete.emit(5);
  }

  getIIBBOptions() {
    this.services.getProvinceIIBB().subscribe((options) => {
      console.log('options', options);
      let location: PotentialCustomer | null = this.sesion.getItem('potential_customer');
      console.log('location', location);
      if (options && location) {
        let state = location.location.state.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        console.log('state1');
        let stateIIBB: ProvinceIibbCategory[] = options.filter((f) => f.state.name == state.toUpperCase());
        console.log('stateIIBB',stateIIBB)
        stateIIBB[0]?.categories?.forEach((element) => {
          this.IIBBOptions.push({
            text: element.name,
            value: element.id,
          });
        });
      }
    });
    if (this.infoAfip?.categorizedAfip && (this.isBsas || this.isCba || this.isEr)) {
      this.IIBBOptions = this.deleteOption(this.IIBBOptions, 'NO INSCRIPTO');
    }
    console.log('IIBBOptions', this.IIBBOptions);
  }

  requiredReba(event: any) {
    if (event.checked) {
      this.taxForm.controls['expiredREBA'].addValidators(Validators.required);
    } else {
      this.taxForm.controls['codeREBA'].clearValidators();
      this.taxForm.controls['codeREBA'].setErrors(null);
      this.taxForm.controls['codeREBA'].setValue('');
      this.taxForm.controls['expiredREBA'].clearValidators();
      this.taxForm.controls['expiredREBA'].setErrors(null);
      this.taxForm.controls['expiredREBA'].setValue('');
    }
    this.taxForm.controls['codeREBA'].updateValueAndValidity();
    this.taxForm.controls['expiredREBA'].updateValueAndValidity();
  }

  setCuitOrCuil(isCuil: boolean) {
    this.submitted = false;
    if (isCuil) {
      this.infoAfip = undefined;
      this.taxForm.controls['noCuit'].setValue(true);
      this.deleteOptionIIBB('CONVENIO MULTILATERAL');
      this.infoAfip = undefined;
      this.taxForm.controls['IIBBCondition'].setValue(IibbCategory.NoInscripto);
    } else {
      this.infoCuil = undefined;
      this.taxForm.controls['noCuit'].setValue(false);
      this.addOptionIIBB('CONVENIO MULTILATERAL', IibbCategory.ConvenioMultilateral);
    }
    this.cd.detectChanges();
  }

  deleteOptionIIBB(text: string) {
    this.IIBBOptions.forEach(function (data, index, object) {
      if (data.text == text) {
        object.splice(index, 1);
      }
    });
    this.cd.detectChanges();
  }

  addOptionIIBB(textData: string, valueData: number) {
    let option: SelectOption = {
      value: valueData,
      text: textData,
    };
    this.IIBBOptions.push(option);
    if (this.convenioMultilateral || this.simplifiedMonotributo) {
      this.taxForm.controls['IIBBCondition'].setValue(valueData);
    } else {
      this.taxForm.controls['IIBBCondition'].setValue('');
    }
    this.cd.detectChanges();
  }

  SetCuitInIIBBNumber() {
    if (!this.taxForm.controls['noCuit'].value) {
      let cuit: string = this.taxForm.controls['cuit'].value;
      this.taxForm.controls['IIBBNumber'].setValue(cuit);
    }
  }

  changeControlsValidations(control: string, required: boolean, max?: number) {
    if (required) {
      this.taxForm.controls[control].addValidators(Validators.required);

      if (max) {
        this.taxForm.controls[control].addValidators(Validators.maxLength(max));
      }
    } else {
      this.taxForm.controls[control].clearValidators();
      this.taxForm.controls[control].setErrors(null);
      this.taxForm.controls[control].setValue('');
    }
  }

  setNotPadronConfiguration(province: string) {
    if (this.infoAfip?.convenioMultilateral) {
      this.setMultilateralAgreementConfiguration();
    } else if (this.infoAfip?.simplifiedMonotributo) {
      this.setUnifiedMonotributo();
    } else {
      this.taxForm.controls['IIBBCondition'].setValue(1);
    }
    if (province == StateName.BuenosAires) {
      this.arbaPadron = false;
      this.alicuota = [8];
    } else if (province == StateName.Cordoba) {
      this.cbaPadron = false;
      this.alicuota = [6];
    } else if (province == StateName.EntreRios) {
      this.erPadron = false;
      this.alicuota = [6];
    } else if (province == StateName.SantaFe) {
      this.sfPadron = false;
      this.alicuota = [6];
    }
  }

  setPadronConfiguration(province: string, alicuota: string) {
    if (this.infoAfip?.convenioMultilateral) {
      this.setMultilateralAgreementConfiguration();
    } else if (this.infoAfip?.simplifiedMonotributo) {
      this.setUnifiedMonotributo();
    }
    if (!this.convenioMultilateral && !this.simplifiedMonotributo) {
      this.deleteOptionIIBB('NO INSCRIPTO');
      this.deleteOptionIIBB('EXENTO');
      this.taxForm.controls['IIBBCondition'].setValue(null);
    }
    if (province == StateName.BuenosAires) {
      this.arbaPadron = true;
    } else if (province ==  StateName.Cordoba) {
      this.cbaPadron = true;
    } else if (province == StateName.EntreRios) {
      this.erPadron = true;
    } else if (province == StateName.SantaFe) {
      this.sfPadron = true;
    }
    let alicuotaParse = alicuota.replace(',', '.');
    this.alicuota = [Number(alicuotaParse)];
  }

  setMultilateralAgreementConfiguration() {
    this.taxForm.controls['IIBBCondition'].setValue(IibbCategory.ConvenioMultilateral);
  }

  setUnifiedMonotributo() {
    this.simplifiedMonotributo = true;
    this.IIBBCondition = IibbCategory.RegimenSimplificado;
    this.changeControlsValidations('IIBBCondition', false);
    this.taxForm.controls['IIBBCondition'].setValue(IibbCategory.RegimenSimplificado);
  }

  async validateDirec(infoAfip: any): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let adressAfip = infoAfip.taxResidence;
      let adressCommerce = this.potentialCustomer?.location;
      let adressAfipParse = this.replaceSpacesWithPlus(adressAfip);
      this.serviceMap.getDirection(adressAfipParse).subscribe(
        (data) => {
          let adressCompleteAfip: string = '';
          if (data.results[0]?.formatted_address) {
            adressCompleteAfip = data.results[0]?.formatted_address;
          }
          let coordinateAdressComplete = {
            lon: data.results[0]?.geometry?.location ? data.results[0]?.geometry?.location?.lng : 0,
            lat: data.results[0]?.geometry?.location ? data.results[0]?.geometry?.location?.lat : 0,
          };
          const coordinateAdressComerce = adressCommerce?.coordinates;
          if (
            adressCompleteAfip == adressCommerce?.address ||
            (coordinateAdressComplete.lat == coordinateAdressComerce?.lat &&
              coordinateAdressComplete.lon == coordinateAdressComerce?.lon)
          ) {
            resolve(true);
          } else {
            resolve(false);
          }
        },
        (error) => {
          reject(new Error('error'));
        },
      );
    });
  }

  replaceSpacesWithPlus(text: string): string {
    return text.replace(/\s+/g, '+');
  }

  private _setFormJurisdiction() {
    this.taxForm.controls['iibbJurisdiction'].setValidators(Validators.required);
    this.taxForm.controls['iibbJurisdiction'].updateValueAndValidity();
    this.showJurisdiction = true;
  }

  private _resetAfipFromSession() {
    if (this.sessionData?.noCuit) {
      this.infoCuil = this.sessionData?.infoCuil;
    } else {
      this.infoAfip = this.sessionData?.infoAfip;
    }
    this.alicuota = this.sessionData?.aliCuota ?? [0];
    this.arbaPadron = this.sessionData?.arbaPadron ?? false;
    this.cbaPadron = this.sessionData?.cbaPadron ?? false;
    this.erPadron = this.sessionData?.erPadron ?? false;
    this.categorizedAfip = this.sessionData?.categorizedAfip ?? false;
  }
}
